var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.134,
    height: 22.406,
    viewBox: "0 0 18.134 22.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f96845;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1507.215 -3014.745)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2019.326 3231.994)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-493.977-217.249q0,11.056,0,22.112v.294h-18.128v-.245q0-7.9,0-15.806a.513.513,0,0,1,.153-.386q2.746-2.888,5.482-5.784c.054-.057.1-.123.148-.185Zm-16.713,6.7v14.3h15.3v-19.584H-505.42v5.284Zm3.865-1.412v-2.7l-2.552,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-495.577-192.592a2.873,2.873,0,0,1-1.722-.593c-.6-.442-1.149-.94-1.712-1.424a.388.388,0,0,0-.327-.119q-1.454.176-2.91.339a.528.528,0,0,0-.439.293,8.692,8.692,0,0,1-1.455,1.934,2.639,2.639,0,0,1-1.51.818,1.508,1.508,0,0,1-1.547-.939,1.25,1.25,0,0,1,.189-1.162,3.922,3.922,0,0,1,1.236-1.094,10.2,10.2,0,0,1,2.082-.952.588.588,0,0,0,.3-.249,8.3,8.3,0,0,0,.951-3.491,13.132,13.132,0,0,0-.123-3.009.73.73,0,0,1,.748-.9.662.662,0,0,1,.645.58c.089.435.127.88.217,1.314a11.016,11.016,0,0,0,1.761,4.293,8.211,8.211,0,0,0,.606.719.46.46,0,0,0,.243.112c.7.131,1.408.231,2.1.391a3.9,3.9,0,0,1,1.539.7,1.216,1.216,0,0,1,.539,1.312,1.452,1.452,0,0,1-1.1,1.075A2.194,2.194,0,0,1-495.577-192.592Zm-4.8-3.516-.845-1.4-.468,1.56Zm-5.284,3.249.045.057.519-.414-.036-.044Z",
    transform: "translate(-2.346 -6.834)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.c54d0142.svg";
export { ForwardRef as ReactComponent };